import * as axios from 'axios'



function upload (formData, onProgress, url) {
  let config = {
    onUploadProgress (progressEvent) {
      var percentCompleted = Math.round((progressEvent.loaded * 10000) /
        progressEvent.total)/100

      // execute the callback
      if (onProgress) onProgress(percentCompleted)

      return percentCompleted
    }
  }
  return axios.post(url, formData, config)
  // get data
    .then(x => x.data)
  // add url field
  //  .then(x => x.map(img => Object.assign({},
  //    img, { url: `${BASE_URL}/assets/${img.id}` })))
}

export {upload}
